// import { SagaIterator } from 'redux-saga';
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/no-anonymous-default-export */
import { call, put, takeLatest } from 'redux-saga/effects';
import { get, size } from 'lodash';
import { getCusReconcilationAPI, getCusReconcilationPaymentAPI, getCusReconcilationPaymentCountAPI, getListMoneyStatisticAPI } from './helpers';
import { getCusReconcilationDone, getCusReconcilationPaymentStatementCountDone, getCusReconcilationPaymentStatementDone, GetMoneyStatisticsDone } from './action';
import { GET_CUS_RECONCILIATION, GET_CUS_RECONCILIATION_PAYMENT_STATEMENT, GET_CUS_RECONCILIATION_PAYMENT_STATEMENT_COUNT, GET_MONEY_STATISTICS } from './constant';

function* takeGetDanhSachDonHangSaga(action: ActionType): any {
  try {
    action.callback?.onBegin?.()
    const data = yield call(getListMoneyStatisticAPI,action.payload);
    if(size(data.data) >= 0 ) {
      action.callback?.onSuccess?.(data.data)
    } else {
      action.callback?.onFail?.("Không có dữ liệu");
    }
    yield put(GetMoneyStatisticsDone(data.data));
  } catch (error) {
    action.callback?.onFail?.(get(error,'response.data',''));
    yield put(GetMoneyStatisticsDone([]));
  } finally {
    action.callback?.onFinish?.()
  }
}

function* takeGetCusReconcilationSaga(action: ActionType): any {
  try {
    action.callback?.onBegin?.()
    const data = yield call(getCusReconcilationAPI,action.payload);
    if(size(data.data) >= 0 ) {
      action.callback?.onSuccess?.(data.data)
    } else {
      action.callback?.onFail?.("Không có dữ liệu");
    }
    yield put(getCusReconcilationDone(data.data));
  } catch (error) {
    action.callback?.onFail?.(get(error,'response.data',''));
    yield put(GetMoneyStatisticsDone([]));
  } finally {
    action.callback?.onFinish?.()
  }
}

function* takeGetCusReconcilationPaymentSaga(action: ActionType): any {
  try {
    action.callback?.onBegin?.()
    const data = yield call(getCusReconcilationPaymentAPI,action.payload);
    if(size(data.data) >= 0 ) {
      action.callback?.onSuccess?.(data.data)
    } else {
      action.callback?.onFail?.("Không có dữ liệu");
    }
    yield put(GetMoneyStatisticsDone(data.data));
  } catch (error) {
    action.callback?.onFail?.(get(error,'response.data',''));
    yield put(getCusReconcilationPaymentStatementDone([]));
  } finally {
    action.callback?.onFinish?.()
  }
}

function* takeGetCusReconcilationPaymentCountSaga(action: ActionType): any {
  try {
    action.callback?.onBegin?.()
    const data = yield call(getCusReconcilationPaymentCountAPI,action.payload);
    if(size(data.data) >= 0 ) {
      action.callback?.onSuccess?.(data.data)
    } else {
      action.callback?.onFail?.("Không có dữ liệu");
    }
    yield put(GetMoneyStatisticsDone(data.data));
  } catch (error) {
    action.callback?.onFail?.(get(error,'response.data',''));
    yield put(getCusReconcilationPaymentStatementCountDone([]));
  } finally {
    action.callback?.onFinish?.()
  }
}

export default function*() {
  yield takeLatest(GET_MONEY_STATISTICS, takeGetDanhSachDonHangSaga);
  yield takeLatest(GET_CUS_RECONCILIATION, takeGetCusReconcilationSaga);
  yield takeLatest(GET_CUS_RECONCILIATION_PAYMENT_STATEMENT, takeGetCusReconcilationPaymentSaga);
  yield takeLatest(GET_CUS_RECONCILIATION_PAYMENT_STATEMENT_COUNT, takeGetCusReconcilationPaymentCountSaga);
}

